<template>
  <div class="mb-4">
    <v-row>
      <v-col cols="12">
        Aqui você pode fazer a <b>importação de um arquivo</b> para criar sua cotação.
        Você deve fornecer uma planilha com duas colunas: <b>Código</b> e <b>Quantidade</b>.
        Nós importaremos os produtos conforme esses dados. Você ainda poderá alterar todas as
        informações antes de enviar a cotação para os fornecedores.
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-file-input
            dense
            show-size
            counter
            multiple
            outlined
            clearable
            class="rounded-tag-small"
            accept=".xls,.xlsx,.tsv,.csv"
            label="Arquivo"
            v-model="arquivos"
            @change="onFileUpload"
        ></v-file-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-alert
            type="warning"
            v-if="fileEmmited && !isValidFile">
          Erro ao importar o arquivo. Verifique o formato e tente novamente.
        </v-alert>
        <v-alert
            type="success"
            v-if="fileEmmited && isValidFile && arquivosResult">
          Encontramos {{ arquivosResult.produtos.length }} produtos para importar nesta cotação.
          Clique em "Continuar" para informar os dados básicos da cotação.
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               :disabled="!arquivosResult || !isValidFile"
               @click="next">
          Continuar
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FileService from '@/api/file-service';
import { first } from 'lodash';

export default {
  data() {
    return {
      arquivos: [],
      arquivosResult: null,
      isValidFile: null,
      fileEmmited: null,
    };
  },
  methods: {
    next() {
      this.$emit('next', this.arquivosResult);
    },
    onFileUpload() {
      if (this.arquivos && this.arquivos.length) {
        this.uploadFile(first(this.arquivos));
        return;
      }

      this.arquivosResult = null;
    },
    uploadFile(file) {
      FileService.upload('cotacoes/importar', file)
        .then(({ data }) => {
          this.arquivosResult = data;
          this.isValidFile = true;
        })
        .catch(() => {
          this.isValidFile = false;
        })
        .finally(() => {
          this.fileEmmited = true;
        });
    },
  },
};
</script>
